import React, { FunctionComponent } from "react";

import "./TaxDisclaimerComponent.scss";

const TaxDisclaimerComponent: FunctionComponent = () => (
  <div className="tax-disclaimer">
    <p>
      El precio final no incluye impuestos. Los pesos de los productos son
      aproximados.
    </p>
  </div>
);

export default TaxDisclaimerComponent;
